<template>
  <div>
    <Question
      :question="question"
      :index="index"
    />
    <VTextField
      v-model="answer"
      class="input"
      required
      outlined
      dense
      type="text"
      :placeholder="$t('enterTheAnswer')"
      :disabled="disabledAnswers"
      @input="answerQuestion()"
    />
  </div>
</template>

<script>
import {
  toRefs, computed, ref, onMounted,
} from '@vue/composition-api';
import Question from './Question.vue';

export default {
  name: 'TextQuestion',
  components: {
    Question,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabledAnswers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { question, answers } = toRefs(props);

    const answer = ref('');

    const isEmptyQuestion = computed(() => !answer.value);

    const isValid = computed(() => !(isEmptyQuestion.value));

    function answerQuestion() {
      const a = {
        questionId: question.value.id,
        answer: answer.value,
        isValid: isValid.value,
      };
      emit('answer', a);
    }

    function setAnswer() {
      const a = {
        questionId: question.value.id,
        answer: answer.value,
        isValid: isValid.value,
      };
      emit('setAnswer', a);
    }

    function getAnswer() {
      if (!answers.value.length) {
        return;
      }
      const a = answers.value.filter(a => a.testQuestionId === question.value.id);
      if (a.length) {
        answer.value = a[0].answer;
        setAnswer();
      }
    }

    onMounted(() => {
      getAnswer();
    });

    return {
      answerQuestion,
      answer,
    };
  },
};
</script>

<style lang="scss" scoped>
.input {
  max-width: 50%;
}
</style>

<i18n locale="en" lang="yaml">
  enterTheAnswer: Enter your answer
</i18n>

<i18n locale="ru" lang="yaml">
  enterTheAnswer: Введите ответ
</i18n>
